







































import Vue, { PropType } from "vue";
import IfaceSyncPartnerDTO from "../../models/IfaceSyncPartnerDTO";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";

interface Props {
  partner: IfaceSyncPartnerDTO;
}

interface Methods {
  goToPartner(): void;
  formatAddress(postcode: string | null, city: string | null, address: string | null): string;
}

interface Computed {
  /** Cím formátum: "irszám, város cím" */
  fullAddress: string;
  /** Levelezési cím formátum: "corIrszám, corVáros corCím" */
  fullCorAddress: string;
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "PartnerInfo",

  components: { SyncStatusBadge },

  props: {
    partner: { type: Object as PropType<IfaceSyncPartnerDTO>, required: true },
  },

  computed: {
    fullAddress(): string {
      return this.formatAddress(this.partner.postcode, this.partner.city, this.partner.address);
    },
    fullCorAddress(): string {
      return this.formatAddress(this.partner.corPostcode, this.partner.corCity, this.partner.corAddress);
    },
  },

  methods: {
    goToPartner() {
      if (this.partner.partner > 1) {
        this.$router.push(`/partners/${this.partner.partner}`);
      }
    },
    /** "irszám, város cím" formátum — az üres részeket kihagyja. */
    formatAddress(postcode: string | null, city: string | null, address: string | null): string {
      const pcCity = [postcode, city].filter(Boolean).join(", ");
      const full = [pcCity, address].filter(Boolean).join(" ");
      return full || "—";
    },
  },
});
